import { EHttpMethod } from '@/common/enums/fetch.enum';

export default class ABApiRoutes {
  public method: EHttpMethod;
  public url: string;

  public static getDoorById = new ABApiRoutes(`/calendar/doors/:id`, EHttpMethod.GET);

  constructor(url: string, method: EHttpMethod) {
    this.method = method;
    this.url = url;
  }
}
